export default [
    {
        path: '/dreamEntry', // 入口
        component: resolve => require(['@/pages/weixinH5/dream/dreamEntry'], resolve),
        meta: { title: "寻找2022个亚运梦想" }
    },{
        path: '/dreamForm', // 表单
        component: resolve => require(['@/pages/weixinH5/dream/dreamForm'], resolve),
        meta: { title: "寻找2022个亚运梦想" }
    },{
        path: '/dreamRecord', // 提交记录
        component: resolve => require(['@/pages/weixinH5/dream/dreamRecord'], resolve),
        meta: { title: "寻找2022个亚运梦想" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/dream.js